const MAX_CONCURRENT_CARD_HYDRATIONS = 2;

type QueueEntry<T> = {
  task: () => Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
};

const queue: QueueEntry<unknown>[] = [];
let activeCount = 0;

function drainQueue(): void {
  while (activeCount < MAX_CONCURRENT_CARD_HYDRATIONS && queue.length > 0) {
    const entry = queue.shift();
    if (!entry) return;

    activeCount += 1;
    void entry.task()
      .then(entry.resolve, entry.reject)
      .finally(() => {
        activeCount -= 1;
        drainQueue();
      });
  }
}

/**
 * Card detail hydration is optional progressive enhancement. Keep it behind a
 * small shared queue so mounting a grid cannot consume every backend request
 * slot and starve feed/search calls.
 */
export function scheduleApplicationDetailHydration<T>(task: () => Promise<T>): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    queue.push({ task, resolve, reject } as QueueEntry<unknown>);
    drainQueue();
  });
}

export const APPLICATION_DETAIL_HYDRATION_CONCURRENCY = MAX_CONCURRENT_CARD_HYDRATIONS;
